import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';


// import logoSample1 from '../../media/article.svg';
import '../style/newspage.css';
import TitledText from './TitledText';

// import { resetNextUuid } from 'react-accessible-accordion';
// import { useParams, useRouteMatch } from 'react-router-dom';

function Anketgazete() {

  return (
    <>
      <Row>
        <Col className="post-header" />
      </Row>
      <Row className="news-post d-flex justify-content-center">
        <Col xs={10} className="depth-shadow">
          <Row>
            <Col md={{ span: 8, offset: 2 }} className="p-5 text-center">
              <TitledText title={"Anket Gazete Çekilişi (Mayıs 2024)"} titleLevel={2} />
            </Col>
          </Row>
          <Row>
            <Col md={{ span: 8, offset: 2 }} className="p-3">
            <iframe src="https://www.dropbox.com/scl/fi/yc2r1wqt0qgouy7oezsxn/Gazete_kamu_ile_paylas.pdf?rlkey=kcrxvf8v20ez9qqril6bjhdod&raw=1" width="100%" height="800" frameborder="0"></iframe>
            

            </Col>
          </Row>

        </Col>
      </Row>
    </>
  );
}

export default Anketgazete;
